<template>
  <PropertyDetailsCard>
    <template #title>Pet Policy</template>
    <template #action>
      <PropertyDetailsCardEditButton v-if="hasInfo" @click="petPolicyModalRef?.modalRef?.show" />
    </template>

    <PropertyPetPolicyInfo v-if="hasInfo" :property="property" />
    <PropertyDetailsCardPlaceholder
      v-else
      title="You haven't added pet policy yet"
      subtitle="Clarify your pet policy to attract pet owners or set restrictions"
      button-text="Add pet policy"
      @button-clicked="showModal"
    />
    <PropertyPetPolicyModal ref="petPolicyModalRef" />
  </PropertyDetailsCard>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';

import { usePropertyStore } from '@tallo/investor/property';
import {
  PropertyDetailsCard,
  PropertyDetailsCardEditButton,
  PropertyDetailsCardPlaceholder,
  PropertyPetPolicyInfo,
} from '@tallo/property';

import PropertyPetPolicyModal from './property-pet-policy-modal.vue';

const { property } = usePropertyStore();
const petPolicyModalRef = ref<InstanceType<typeof PropertyPetPolicyModal>>();
const hasInfo = computed(() => Boolean(property?.petPolicy));

function showModal() {
  petPolicyModalRef.value?.modalRef?.show();
}
</script>
